import { Box } from "@mui/material";
import { TabLink, TabLinks } from "components/TabLinks";
import { useMemo } from "react";
import { Navigate, Outlet, matchPath, useLocation } from "react-router-dom";

export function WorkflowConfig() {
  const { pathname } = useLocation();

  const tabs: TabLink[] = useMemo(
    () => [
      {
        title: "Rules",
        to: "/staff/workflow-config/rules",
      },
      {
        title: "Denied Facilities",
        to: "/staff/workflow-config/denied-facilities",
      },
      {
        title: "Facility Pilot Program",
        to: "/staff/workflow-config/pilot-program",
      },
    ],
    []
  );

  const currentTab = tabs.find(({ to }) => matchPath(`${to}/*`, pathname));

  // Redirect to first tab if we don't have a match
  if (!currentTab) {
    return <Navigate to={tabs[0].to} replace={true} />;
  }

  const tabIndex = tabs.indexOf(currentTab);

  return (
    <Box>
      <TabLinks
        value={tabs[tabIndex].to}
        tabs={tabs}
        aria-label="workflow config tabs nav"
        role="navigation"
      />
      <Outlet />
    </Box>
  );
}
